export default "/assets/site/images/mavir_gray_logo.png?5a084809a559eef4f4900837ba7224ea";